export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar exámen'},
			},

			tableGBSearch: ['datos_pacientes/documento','datos_pacientes/name'],
			
			tableGBItems: [				
				{
					thead: { th: "Fecha exámen" },
					tbody: { td: [ "info_examens/created_at" ]}
				},
				{
					thead: { th: "Exámen"},
					tbody: { td: [ "info_examens/id" ], link: '/api/pdf/examen' }
				},
				{
					thead: { th: "Diagnostico"},
					tbody: { td: [ "info_examens/id" ], link: '/api/pdf/diagnosticos' }
				},
			]						
		}
	},
}